import ServiceEndpoints from "./ServiceEndpoints";

export interface FieldGuidanceData {
    reasonForRequest: string;
    infoRequested: string;
}

export async function fetchCoreFieldGuidance(userToken?: string): Promise<FieldGuidanceData> {
    return await fetch(ServiceEndpoints.FetchCoreFieldGuidance, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + userToken,
        },
    }).then(async (resp) => {
        const data = await resp.json();
        return {
            reasonForRequest: data.reasonForRequest ?? '',
            infoRequested: data.infoRequested ?? '',
        } as FieldGuidanceData;
    }).catch((error) => {
        console.error("Error fetching field guidance:", error);
        return { reasonForRequest: '', infoRequested: '' };
    });
}
